import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="sm">
              <ArrowLeft size={20} className="mr-2" />
              Назад
            </Button>
          </Link>
          <h1 className="font-heading text-xl font-bold text-primary">КОНФИДЕНЦИАЛЬНОСТЬ</h1>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <h2 className="text-3xl font-bold text-foreground mb-8">Политика конфиденциальности</h2>
        
        <div className="prose prose-invert max-w-none space-y-6 text-muted-foreground">
          <p className="text-lg">
            Ваша конфиденциальность важна для нас. Настоящая политика объясняет, 
            какие данные мы собираем и как их используем.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">1. Собираемые данные</h3>
          <p>Мы собираем следующую информацию:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>Email адрес (для связи по заявке)</li>
            <li>Адреса криптовалютных кошельков</li>
            <li>Telegram username (опционально)</li>
            <li>IP адрес и данные браузера</li>
            <li>История транзакций</li>
          </ul>

          <h3 className="text-xl font-bold text-foreground mt-8">2. Использование данных</h3>
          <p>Мы используем ваши данные для:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>Обработки обменных операций</li>
            <li>Связи с вами по вопросам заявок</li>
            <li>Предотвращения мошенничества</li>
            <li>Улучшения качества сервиса</li>
            <li>Соблюдения требований законодательства</li>
          </ul>

          <h3 className="text-xl font-bold text-foreground mt-8">3. Защита данных</h3>
          <p>
            Мы применяем современные методы защиты данных, включая шифрование SSL/TLS 
            и безопасное хранение информации на защищённых серверах.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">4. Cookies</h3>
          <p>
            Мы используем cookies для улучшения работы сайта, сохранения настроек 
            и анализа посещаемости. Вы можете отключить cookies в настройках браузера.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">5. Передача данных третьим лицам</h3>
          <p>
            Мы не продаём и не передаём ваши данные третьим лицам, за исключением случаев:
          </p>
          <ul className="list-disc list-inside space-y-2">
            <li>Требования правоохранительных органов</li>
            <li>Необходимости для выполнения транзакций</li>
            <li>Вашего явного согласия</li>
          </ul>

          <h3 className="text-xl font-bold text-foreground mt-8">6. Хранение данных</h3>
          <p>
            Данные о транзакциях хранятся в течение 5 лет в соответствии с требованиями 
            законодательства о противодействии отмыванию денег.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">7. Ваши права</h3>
          <p>Вы имеете право:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>Запросить информацию о ваших данных</li>
            <li>Исправить неточные данные</li>
            <li>Удалить данные (с учётом законодательных требований)</li>
            <li>Отозвать согласие на обработку</li>
          </ul>

          <h3 className="text-xl font-bold text-foreground mt-8">8. Контакты</h3>
          <p>
            По вопросам конфиденциальности: privacy@skinkosh.com
          </p>

          <p className="text-sm text-muted-foreground mt-8">
            Последнее обновление: Декабрь 2025
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
